import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Nav from "./components/landing/Nav";
import Hero from "./components/landing/Hero";
import Stats from "./components/landing/Stats";
import Editorial from "./components/landing/Editorial";
import CraftedFor from "./components/landing/CraftedFor";
import Highlights from "./components/landing/Highlights";
import Itinerary from "./components/landing/Itinerary";
import PackagePrice from "./components/landing/PackagePrice";
import Inclusions from "./components/landing/Inclusions";
import Experiences from "./components/landing/Experiences";
import Faq from "./components/landing/Faq";
import Closing from "./components/landing/Closing";
import EnquiryForm from "./components/landing/EnquiryForm";
import Footer from "./components/landing/Footer";

const ScrollContext = createContext(() => {});
export const useSmoothScroll = () => useContext(ScrollContext);

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -60, duration: 1.5 });
    }
  };

  return (
    <ScrollContext.Provider value={scrollTo}>
      <div className="relative min-h-screen bg-ivory text-ink antialiased">
        <div className="grain pointer-events-none fixed inset-0 z-[60]" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Stats />
          <Editorial />
          <CraftedFor />
          <Highlights />
          <Itinerary />
          <PackagePrice />
          <Inclusions />
          <Experiences />
          <Faq />
          <Closing />
          <EnquiryForm />
        </main>
        <Footer />
        <Toaster position="top-center" toastOptions={{ style: { background: "#14251B", color: "#F6F2E6", border: "1px solid rgba(232,134,46,0.4)" } }} />
      </div>
    </ScrollContext.Provider>
  );
}

export default App;
